import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '@/modules/common/components/Select';
import TextField from '@/modules/common/components/TextField';

const Form = (props) => {
    return (
        <>
            <Select label="Оффер"
                    options={props.cfgOffers.map((cfgOffer) => ({title: cfgOffer.offer_name, value: cfgOffer.id}))}
                    value={props.values.offer}
                    onChange={props.onChange('offer')}
                    error={props.errors.offer.length > 0}
                    helperText={props.errors.offer}
                    onFocus={props.onFocus('offer')}
                    autoFocus={true}
            />
            <TextField label="Тема"
                       value={props.values.subject}
                       onChange={props.onChange('subject')}
                       error={props.errors.subject.length > 0}
                       helperText={props.errors.subject}
                       onFocus={props.onFocus('subject')}
            />
            <TextField label="Заметка" multiline={true}
                       value={props.values.note}
                       onChange={props.onChange('note')}
                       error={props.errors.note.length > 0}
                       helperText={props.errors.note}
                       onFocus={props.onFocus('note')}
            />
        </>
    );
};

Form.propTypes = {
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    onFocus: PropTypes.func.isRequired,
};

export default connect(
    (state) => ({
        cfgOffers: state.cfg.offers,
    })
)(Form);
